<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;900"
      type="text/css">
<link href="https://fonts.googleapis.com/css2?family=Fira+Sans:wght@100;200;300;400;500;700&display=swap"
      rel="stylesheet">
<ngx-loading [show]="loading"></ngx-loading>
<div class="card bg-light shadow border-0 receipt min-vh-100 pt-2" id="pdf-content">

  <div [@cardAnimation]="notificationAnimationState">
    <div class="d-flex align-items-center mt-4 receipt-sent">
      <!-- Check Icon -->
      <div class="">
        <svg class="check-icon" width="28" height="28" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM14.5234 8.27344C14.9492 7.84766 14.9492 7.15234 14.5234 6.72656C14.0977 6.30078 13.4023 6.30078 12.9766 6.72656L8.75 10.9531L7.02344 9.22656C6.59766 8.80078 5.90234 8.80078 5.47656 9.22656C5.05078 9.65234 5.05078 10.3477 5.47656 10.7734L7.97656 13.2734C8.40234 13.6992 9.09766 13.6992 9.52344 13.2734L14.5234 8.27344Z"
            fill="#00CB44"/>
        </svg>
      </div>

      <!-- Text Content -->
      <div class="flex-grow-1">
        <div class="receipt-text ml-2">
          Receipt sent to<br>
          <span class="email-text">{{ emailAddress }}</span>
        </div>
      </div>

      <!-- Close Button -->
      <button class="close" (click)="toggleReceiptSentNotification()" style="outline: none;">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="text-center mt-3">
    <svg class="check-icon" width="100" height="100" viewBox="0 0 20 20" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM14.5234 8.27344C14.9492 7.84766 14.9492 7.15234 14.5234 6.72656C14.0977 6.30078 13.4023 6.30078 12.9766 6.72656L8.75 10.9531L7.02344 9.22656C6.59766 8.80078 5.90234 8.80078 5.47656 9.22656C5.05078 9.65234 5.05078 10.3477 5.47656 10.7734L7.97656 13.2734C8.40234 13.6992 9.09766 13.6992 9.52344 13.2734L14.5234 8.27344Z"
        fill="#a3d1b3"/>
    </svg>

    <h3 class="mt-4 mx-2">Top-up Successful</h3>
    <div class="m-2 px-5">You have successfully
      added {{ topup?.merchant?.currency?.symbol + (topup?.topupAmount | number : '1.2-2') }}
      to your gift card.
    </div>
  </div>

  <div class="card-body border bg-white">

    <div class="d-flex flex-row justify-content-between">
      <div class="h4 font-weight-bold">Receipt</div>
      <div class="font-weight-light">No. {{ topup?.id }}</div>
    </div>

    <hr class="mt-1 receipt-thin-separator">

    <div class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>Top-up Amount</div>
        <div
          class="font-weight-bold">{{ topup?.merchant?.currency?.symbol + (topup?.topupAmount | number : '1.2-2') }}
        </div>
      </div>
    </div>
    <div class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>Previous Balance</div>
        <div
          class="font-weight-bold">{{ topup?.merchant?.currency?.symbol + (topup?.previousBalance | number : '1.2-2') }}
        </div>
      </div>
    </div>
    <div class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>New Balance</div>
        <div
          class="font-weight-bold text-success">{{ topup?.merchant?.currency?.symbol + (topup?.giftCard?.balance | number : '1.2-2') }}
        </div>
      </div>
    </div>

    <div *ngIf="topup?.giftCard?.number" class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>Gift Card</div>
        <div>**** {{ topup?.giftCard?.number | slice: -4 }}</div>
      </div>
    </div>
    <div class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>Date & Time</div>
        <div>{{ topup?.createdDate | date: 'MMM d, y HH:mm' }}</div>
      </div>
    </div>
    <div class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>Merchant</div>
        <div>{{ topup?.merchant?.name }}</div>
      </div>
    </div>
    <div *ngIf="topup?.merchant?.address" class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>Address</div>
        <div>{{ topup?.merchant?.address }}</div>
      </div>
    </div>
    <div *ngIf="topup?.merchant?.vatNumber" class="mt-2 text-right">
      <div class="d-flex justify-content-between">
        <div>VAT No.</div>
        <div>{{ topup?.merchant?.vatNumber }}</div>
      </div>
    </div>

    <hr class="receipt-thin-separator my-2">

    <div *ngIf="topup?.payment?.id" class="mt-2 text-small font-weight-light">
      <div class="d-flex justify-content-between">
        <div>Transaction No.</div>
        <div>{{ topup?.payment?.id }}</div>
      </div>
    </div>

    <div *ngIf="topup?.payment?.bankMIDId" class="mt-2 text-small font-weight-light">
      <div class="d-flex justify-content-between">
        <div>Bank MID</div>
        <div>****{{ topup?.payment?.bankMIDId | slice:-4 }}</div>
      </div>
    </div>

    <div *ngIf="topup?.payment?.approvalCode" class="mt-2 text-small font-weight-light">
      <div class="d-flex justify-content-between">
        <div>Approval Code</div>
        <div>{{ topup?.payment?.approvalCode }}</div>
      </div>
    </div>

    <div *ngIf="topup?.payment?.settledAmount" class="mt-2 text-small font-weight-light">
      <div class="d-flex justify-content-between">
        <div>Transaction Amount</div>
        <div>{{ topup?.merchant?.currency?.symbol + (topup?.payment?.settledAmount | number : '1.2-2') }}</div>
      </div>
    </div>

    <div class="text-center mt-3" data-html2canvas-ignore="true">

      <div *ngIf="getDeviceType() === 'other'; else addToWallet" class="d-flex">
        <a style="color:#000;text-decoration: none;font-weight: 600; display: inline-block;" [href]="appleWalletLink">
          <img width="180" alt=""
               src="https://upcofile.s3.eu-west-1.amazonaws.com/webgiftcard-assets/add-to-apple-wallet-logo.png">
        </a>

        <div class="btn scan-card-btn cursor-pointer d-flex align-items-center justify-content-center ml-5"
             (click)="toggleDownloadSection()">
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.6786 5H13.25C12.9161 5 12.6429 5.28125 12.6429 5.625C12.6429 5.96875 12.9161 6.25 13.25 6.25H15.6786C16.0125 6.25 16.2857 6.53125 16.2857 6.875V18.125C16.2857 18.4692 16.013 18.75 15.6786 18.75H2.32143C1.98712 18.75 1.71429 18.4688 1.71429 18.125V6.875C1.71429 6.53125 1.98712 6.25 2.32143 6.25H4.75C5.08393 6.25 5.35714 5.96875 5.35714 5.625C5.35714 5.28125 5.08393 5 4.75 5H2.32143C1.31699 5 0.5 5.83984 0.5 6.875V18.125C0.5 19.1602 1.31699 20 2.32143 20H15.6786C16.683 20 17.5 19.159 17.5 18.125V6.875C17.5 5.83984 16.6842 5 15.6786 5ZM4.92835 10.1836C4.69118 10.4277 4.69118 10.8234 4.92835 11.0672L8.57121 14.8172C8.68884 14.9375 8.84442 15 9 15C9.15558 15 9.31071 14.939 9.42917 14.8169L13.072 11.0669C13.3092 10.8227 13.3092 10.427 13.072 10.1833C12.8349 9.93953 12.4505 9.93914 12.2137 10.1833L9.60714 12.8672V0.625C9.60714 0.279531 9.33393 0 9 0C8.66607 0 8.39286 0.279531 8.39286 0.625V12.8672L5.78594 10.1836C5.55067 9.9375 5.16362 9.9375 4.92835 10.1836Z"
              fill="#3D45E0"/>
          </svg>
        </div>
      </div>

      <ng-template #addToWallet>
        <div class="d-flex">
          <a *ngIf="getDeviceType() === 'android'"
             style="color:#000;text-decoration: none;font-weight: 600; display: inline-block;"
             [href]="googleWalletLink">
            <img width="190" alt=""
                 src="https://upcofile.s3.eu-west-1.amazonaws.com/webgiftcard-assets/add-to-google-wallet-logo.png">
          </a>

          <a *ngIf="getDeviceType() === 'ios'"
             style="color:#000;text-decoration: none;font-weight: 600; display: inline-block;" [href]="appleWalletLink">
            <img width="180" alt=""
                 src="https://upcofile.s3.eu-west-1.amazonaws.com/webgiftcard-assets/add-to-apple-wallet-logo.png">
          </a>

          <div class="btn scan-card-btn cursor-pointer d-flex align-items-center justify-content-center ml-5"
               (click)="toggleDownloadSection()">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.6786 5H13.25C12.9161 5 12.6429 5.28125 12.6429 5.625C12.6429 5.96875 12.9161 6.25 13.25 6.25H15.6786C16.0125 6.25 16.2857 6.53125 16.2857 6.875V18.125C16.2857 18.4692 16.013 18.75 15.6786 18.75H2.32143C1.98712 18.75 1.71429 18.4688 1.71429 18.125V6.875C1.71429 6.53125 1.98712 6.25 2.32143 6.25H4.75C5.08393 6.25 5.35714 5.96875 5.35714 5.625C5.35714 5.28125 5.08393 5 4.75 5H2.32143C1.31699 5 0.5 5.83984 0.5 6.875V18.125C0.5 19.1602 1.31699 20 2.32143 20H15.6786C16.683 20 17.5 19.159 17.5 18.125V6.875C17.5 5.83984 16.6842 5 15.6786 5ZM4.92835 10.1836C4.69118 10.4277 4.69118 10.8234 4.92835 11.0672L8.57121 14.8172C8.68884 14.9375 8.84442 15 9 15C9.15558 15 9.31071 14.939 9.42917 14.8169L13.072 11.0669C13.3092 10.8227 13.3092 10.427 13.072 10.1833C12.8349 9.93953 12.4505 9.93914 12.2137 10.1833L9.60714 12.8672V0.625C9.60714 0.279531 9.33393 0 9 0C8.66607 0 8.39286 0.279531 8.39286 0.625V12.8672L5.78594 10.1836C5.55067 9.9375 5.16362 9.9375 4.92835 10.1836Z"
                fill="#3D45E0"/>
            </svg>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div *ngIf="shouldSaveReceipt" class="rounded-top shadow-top" data-html2canvas-ignore="true">
    <div class="modal-backdrop fade show"
         (click)="toggleDownloadSection()"
         style="z-index: 1040;">
    </div>

    <!-- Notification panel -->
    <div class="notification-panel" [@slideDown]>

      <div class="d-flex justify-content-end p-3 border-bottom text-right">
        <button class="close" (click)="toggleDownloadSection()" style="outline: none;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Save receipt section -->
      <div class="p-3 border-bottom">
        <a class="btn btn-link text-purple p-0 d-flex align-items-center font-weight-normal" (click)="saveAsPDF()">
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.6786 5H13.25C12.9161 5 12.6429 5.28125 12.6429 5.625C12.6429 5.96875 12.9161 6.25 13.25 6.25H15.6786C16.0125 6.25 16.2857 6.53125 16.2857 6.875V18.125C16.2857 18.4692 16.013 18.75 15.6786 18.75H2.32143C1.98712 18.75 1.71429 18.4688 1.71429 18.125V6.875C1.71429 6.53125 1.98712 6.25 2.32143 6.25H4.75C5.08393 6.25 5.35714 5.96875 5.35714 5.625C5.35714 5.28125 5.08393 5 4.75 5H2.32143C1.31699 5 0.5 5.83984 0.5 6.875V18.125C0.5 19.1602 1.31699 20 2.32143 20H15.6786C16.683 20 17.5 19.159 17.5 18.125V6.875C17.5 5.83984 16.6842 5 15.6786 5ZM4.92835 10.1836C4.69118 10.4277 4.69118 10.8234 4.92835 11.0672L8.57121 14.8172C8.68884 14.9375 8.84442 15 9 15C9.15558 15 9.31071 14.939 9.42917 14.8169L13.072 11.0669C13.3092 10.8227 13.3092 10.427 13.072 10.1833C12.8349 9.93953 12.4505 9.93914 12.2137 10.1833L9.60714 12.8672V0.625C9.60714 0.279531 9.33393 0 9 0C8.66607 0 8.39286 0.279531 8.39286 0.625V12.8672L5.78594 10.1836C5.55067 9.9375 5.16362 9.9375 4.92835 10.1836Z"
              fill="#3D45E0"/>
          </svg>
          <span class="ml-2 pt-1">Save receipt</span>
        </a>
      </div>

      <div class="p-3 pb-5" *ngIf="!sendReceipt">
        <a class="btn btn-link text-purple p-0 d-flex align-items-center font-weight-normal"
           (click)="sendReceipt = true">
          <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 3C0 1.61914 1.11914 0.5 2.5 0.5H17.5C18.8789 0.5 20 1.61914 20 3V13C20 14.3789 18.8789 15.5 17.5 15.5H2.5C1.11914 15.5 0 14.3789 0 13V3ZM1.25 3V4.55859L8.89062 10.1602C9.55078 10.6445 10.4492 10.6445 11.1094 10.1602L18.75 4.55859V3C18.75 2.30859 18.1914 1.75 17.5 1.75H2.46484C1.80977 1.75 1.21484 2.30859 1.21484 3H1.25ZM1.25 6.10938V13C1.25 13.6914 1.80977 14.25 2.5 14.25H17.5C18.1914 14.25 18.75 13.6914 18.75 13V6.10938L11.8477 11.168C10.7461 11.9766 9.25391 11.9766 8.15234 11.168L1.25 6.10938Z"
              fill="#3D45E0"/>
          </svg>
          <span class="ml-2">Email receipt to myself</span>
        </a>
      </div>

      <!-- Email receipt section -->
      <div class="p-3 pb-5" *ngIf="sendReceipt">
        <h6 class="mb-3">Email receipt to myself</h6>
        <div>
          <div class="form-group mt-3">
            <input type="email" [(ngModel)]="emailAddress" placeholder="Email" required
                   class="form-control">
          </div>

          <div class="text-center mt-3">
            <button class="btn btn-dark dark-button w-100"
                    [disabled]="!emailAddress || !emailAddress.match(emailRegex) || isSendingEmail"
                    (click)="sendEmail()">
              <span *ngIf="!isSendingEmail">Send</span>
              <span *ngIf="isSendingEmail">Sending...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3 d-flex justify-content-center" data-html2canvas-ignore="true">
    <a href="https://www.cancer.org/donate.html" target="_blank"
       class="cursor-pointer">
      <img [@slideDown]
           src="/assets/img/donate.png"
           alt="DONATE">
    </a>
  </div>

  <div class="container-fluid bg-light my-1" data-html2canvas-ignore="true">

    <app-feedback-section [merchantId]="topup?.merchant?.id"
                          [config]="{ leaveReview: false, netPromoterScore: true, customerSatisfaction: false }">
    </app-feedback-section>

    <div>
      <div class="d-flex justify-content-center align-items-center flex-column my-3 fs-11">
        <div class="receipt-img d-flex justify-content-center">
          <img class="img-fluid w-30 mt-2 mb-4 rounded" src="{{ topup?.merchant?.imageURL }}"/>
        </div>
        <span>© {{ currentDate | date:'yyyy' }}, {{ topup?.merchant?.name }}</span>
        <span>{{ topup?.merchant?.address }}</span>
        <span>
            <span
            >T: {{ topup?.merchant?.phoneNumber }}</span>
            <span
            > | </span>
            <span
            >E: {{ topup?.merchant?.contactEmail }}</span>
          </span>
      </div>

      <div class="row justify-content-center">
        <div class="col-auto">
          <div class="d-flex gap-3">
            <a *ngFor="let socialLink of topup?.merchant?.merchantSocialLinks"
               [href]="socialLink.link"
               target="_blank"
               rel="noopener noreferrer"
               class="text-decoration-none"
               [attr.aria-label]="socialLink.name">
              <div class="bg-black rounded-circle d-flex align-items-center justify-content-center"
                   style="width: 48px; height: 48px;">
                <fa-icon [icon]="getSocialIcon(socialLink.name)"
                         class="text-white"
                         size="lg">
                </fa-icon>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-center receipt-footer">
    <div class="col-7">
      <div class="ml-3 mb-1 text-white small">Powered by</div>
      <img class="col-12" src="/assets/img/f-logo.svg"/>
    </div>
    <div class="col-5 d-flex justify-content-end pr-4">
      <a href="https://supersweet.ai/" class="arrow-link text-white" target="_blank">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.2"/>
          <path
            d="M25.8115 15.7929L33.668 23.2305C33.88 23.4311 34 23.7091 34 23.9999C34 24.2908 33.88 24.5684 33.668 24.7694L25.8115 32.2069C25.3832 32.6109 24.7053 32.5957 24.2964 32.171C23.8877 31.7504 23.9031 31.0752 24.3327 30.6684L30.2563 25.0637H15.0718C14.4803 25.0637 14 24.5873 14 24.0007C14 23.4141 14.4803 22.9386 15.0718 22.9386H30.2535L24.3299 17.3339C23.9009 16.9263 23.8876 16.2511 24.2938 15.8292C24.7044 15.4042 25.3428 15.3892 25.8115 15.7929Z"
            fill="white"/>
        </svg>
      </a>
    </div>
  </div>
  <img class="mh-12" src="/assets/img/supersweet-ribbon.png"/>
</div>